import local from "./configs/local";
import integration from "./configs/integration";
import prod from "./configs/prod";

export type EnvConfig = {
  basketBFFBaseUrl: string;
  socialProofApi: string;
  onlineStockBaseUrl: string;
  onlineStockApiKey: string;
  hostUrl: string;
};

const IS_FLEX =
  typeof window !== "undefined" &&
  window.origin.includes("integration.project4.com");
const IS_PROD =
  typeof window !== "undefined" && window.origin.includes("johnlewis.com");

const config = IS_PROD ? prod : IS_FLEX ? integration : local;

export default config;
